import { CheckIcon } from '@heroicons/react/24/outline';
import { Input } from '@library/components/inputs';

export interface ConfirmationInputProps {
  confirmationInputValue: string;
  setConfirmationInputValue: (value: string) => void;
}

export const ConfirmationInput = ({
  confirmationInputValue,
  setConfirmationInputValue
}: ConfirmationInputProps) => {
  const isConfirmationInputValid = confirmationInputValue === 'CONFIRM';

  return (
    <>
      <p className="text-soClean-180 mb-2 mt-6 text-sm">
        Type CONFIRM into the box below to proceed
      </p>
      <div className="relative">
        <Input
          value={confirmationInputValue}
          onValueChange={setConfirmationInputValue}
        />
        {isConfirmationInputValid && (
          <CheckIcon className="stroke-atlien-100 absolute inset-y-3 right-3 size-4 stroke-2" />
        )}
      </div>
    </>
  );
};
